import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ReportIdentifier {
  ticker: string;
  fiscalPeriod: string;
  fiscalYear: string;
}

export interface TranscriptIdentifier {
  ticker: string;
  fiscalDateEnding: string;
}

export interface ConversationLayout {
  selectedEarningsReport: ReportIdentifier | null;
  selectedTranscript: TranscriptIdentifier | null;
  enlargedReport: boolean;
  columnOrder: string[];
}

export interface LayoutState {
  [conversationId: string]: ConversationLayout;
}

const initialState: LayoutState = {};

const getInitialLayout = (): ConversationLayout => ({
    selectedEarningsReport: null,
    selectedTranscript: null,
    enlargedReport: true,
    columnOrder: ['earnings', 'chat', 'transcript'],
});

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setSelectedEarningsReport(state, action: PayloadAction<{ conversationId: string; report: ReportIdentifier | null }>) {
      const { conversationId, report } = action.payload;
      if (!state[conversationId]) state[conversationId] = getInitialLayout();
      state[conversationId].selectedEarningsReport = report;
    },
    setSelectedTranscript(state, action: PayloadAction<{ conversationId: string; transcript: TranscriptIdentifier | null }>) {
      const { conversationId, transcript } = action.payload;
      if (!state[conversationId]) state[conversationId] = getInitialLayout();
      state[conversationId].selectedTranscript = transcript;
    },
    setEnlargedReport(state, action: PayloadAction<{ conversationId: string; enlarged: boolean }>) {
      const { conversationId, enlarged } = action.payload;
      if (!state[conversationId]) state[conversationId] = getInitialLayout();
      state[conversationId].enlargedReport = enlarged;
    },
    setColumnOrder(state, action: PayloadAction<{ conversationId: string; columnOrder: string[] }>) {
      const { conversationId, columnOrder } = action.payload;
      if (!state[conversationId]) state[conversationId] = getInitialLayout();
      state[conversationId].columnOrder = columnOrder;
    },
  },
});

export const {
  setSelectedEarningsReport,
  setSelectedTranscript,
  setEnlargedReport,
  setColumnOrder,
} = layoutSlice.actions;

export default layoutSlice.reducer;
